import type { Chat } from '@mint-sdk/api-ai-assistant';
import { useAtomValue, useSetAtom } from 'jotai';

import { agenticMetadataAtom } from './metadataReducer.js';
import { aiMetadataTemplates } from './metadataTemplates.js';

const useMetadataCollector = () => {
  const agenticMetadata = useAtomValue(agenticMetadataAtom);
  const setAgenticMetadata = useSetAtom(agenticMetadataAtom);
  return {
    agenticMetadata,
    setAgenticMetadata,
  };
};

const usePromptMetadataGenerator = () => {
  const { agenticMetadata } = useMetadataCollector();

  const entityConfig: Record<string, { entity: number | string | undefined }> =
    {
      '/notifications': {
        entity: agenticMetadata.recommendation.suggestion?.id,
      },
    };

  const isEntityScope = (pageRootPath: string) => {
    return !!entityConfig[pageRootPath]?.entity;
  };

  const customMetadataTemplates: Record<
    string,
    Record<string, Chat.ChatDetailsQueryType>
  > = {
    '/notifications': {
      page: {
        scopeType: 'PAGE',
        scopePath: '/notification-hub',
        entityType: null,
        entityId: null,
      },
      entity: {
        scopeType: 'ENTITY',
        scopePath: '/notification-hub',
        entityType: 'suggestion',
        entityId: String(agenticMetadata.recommendation.suggestion?.id),
      },
    },
  };

  const generateCustomTemplate = (pageRootPath: string) => {
    if (customMetadataTemplates[pageRootPath]) {
      return isEntityScope(pageRootPath)
        ? customMetadataTemplates[pageRootPath].entity
        : customMetadataTemplates[pageRootPath].page;
    }

    return aiMetadataTemplates.agentic;
  };

  const generateCustomMetadata = (pageRootPath: string) => {
    if (!agenticMetadata.recommendation.suggestion) return null;

    const customMetadata: Record<string, Chat.UserMetadataSchemaType> = {
      '/notifications': {
        reco: { recoId: agenticMetadata.recommendation.suggestion?.id },
      },
    };

    if (customMetadata[pageRootPath]) {
      return isEntityScope(pageRootPath) ? customMetadata[pageRootPath] : null;
    }
  };

  return {
    generateCustomTemplate,
    generateCustomMetadata,
  };
};

export { useMetadataCollector, usePromptMetadataGenerator };
